import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-circle",
  "use": "svg-circle-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" fill=\"currentColor\" id=\"svg-circle\"><g><circle cx=\"50\" cy=\"50\" r=\"50\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol